import { render, staticRenderFns } from "./SpringpayLanding.vue?vue&type=template&id=981043c8&"
import script from "./SpringpayLanding.vue?vue&type=script&lang=js&"
export * from "./SpringpayLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports